<template lang="pug">
  .container-fluid.p-0.h-100(v-if="dataReady")
    header.header.row
      .logo-and-showmenu.col-6.col-lg-4.col-xl-3.col-md-5.col-sm-5.ml-3
        button.showmenu(type="button" title="show left menu" v-on:click="showMenu = !showMenu")
          i.fas.fa-bars
        .main-logo
          //- img.col-11.col-xl-4.col-lg-4.col-md-4.col-sm-11(src="../src/assets/images/logo.png" alt="main logo" style="width:200px")
          .d-none.d-md-block Деловой разговор
      .d-flex.justify-content-end.align-items-center.col.dropdown.mr-3
        p.m-0 {{ currentUser.name }}
        button.name-and-status.btn(type="button" v-on:click="dropdownMenu = !dropdownMenu")
          i.fas.fa-user
        .dropdown_menu(v-show="dropdownMenu")
          .dropdown_menu-item {{ currentUser.name }}
          router-link.dropdown_menu-item(v-bind:to="'/help'") Помощь
          a.dropdown_menu-item(href="#" v-if="currentUser.sub_user_id > 0" v-on:click="subQuit()") Выйти из пользователя
          a.dropdown_menu-item(href="#" v-else v-on:click="quit()") Выйти
    .row.w-100.h-100.m-0
      div(v-bind:class="['left-block', {'col-1_5': !showMenu},{'col-0_5': showMenu}]")
        nav.nav
          ul.nav-list.h-100.m-0
            template(v-for="link in linkMenu")
              li.nav-item(v-if="(!!currentUser.rights[link.access] && currentUser.rights[link.access] == true) || link.access == ''")
                router-link(v-bind:to="menuState.active ? link.url : ''" v-bind:class="['nav-link', menuState.active ? true : 'router-link-inactive']" v-on:click.native="menuState.active ? true : checkMenuState()")
                  i(v-bind:class="['far', 'fa-fw', link.icon]")
                  span.nav-item-description {{ link.title }}
      div.right-block.p-0.col
        .alert.alert-danger.alert-dismissible.fade.show.col-12.text-center(v-if="alertState.active")
          button.close(type="button" v-on:click="alertState.active = !alertState.active")
            span &times;
          strong {{ alertState.message }}
        main.main-content
          .content-wrapper.w-100.text-center(v-if="accessDenial.active")
            h2.py-5 {{accessDenial.message}}
          router-view
  .text-light.m-auto(v-else)
    i.fas.fa-spinner.fa-pulse.mr-2
    span Идёт загрузка данных
</template>

<script>
export default {
  data () {
    return {
      showMenu: false,
      dropdownMenu: false,
      generatePass: '',
      dataReady: false,
      linkMenu: [
        {title: 'Главная', url: '/', icon: 'fa-home', access: ''},
        {title: 'Мониторинг', url: '/monitoring', icon: ' fa-desktop', access: 'monitoring'},
        {title: 'Обзвон', url: '/calls', icon: 'fa-phone', access: 'doCalls'},
        {title: 'Звонки', url: '/callslist', icon: 'fa-phone', access: 'callsList'},
        {title: 'Контакты', url: '/baselist', icon: 'fa-clipboard-list', access: 'baseList'},
        {title: 'Проекты', url: '/projects', icon: 'fa-file', access: 'projects'},
        {title: 'Статистика', url: '/stat', icon: 'fa-chart-line', access: 'stat'},
        {title: 'Настройки', url: '/settings', icon: 'fa-cogs', access: 'settings'},
        {title: 'Клиенты', url: '/clients', icon: 'fa-users', access: 'clients'},
        {title: 'Сотрудники', url: '/users', icon: 'fa-users', access: 'staff'},
        // {title: 'Помощь', url: '/help', icon: 'fa-question-circle', access: ''},
        {title: 'Редактор', url: '/diagramEditor', icon: 'fa-question-circle', access: 'scriptEditor'},
        {title: 'Проекты sim', url: '/simCallsProjects', icon: 'fa-file', access: 'simCallsProjects'},
        {title: 'Базы sim', url: '/simCallsBases', icon: 'fa-file', access: 'simCallsBases'},
        {title: 'Шлюзы sim', url: '/simCallsGateways', icon: 'fa-file', access: 'simCallsGateways'},
        {title: 'Провайдеры sim', url: '/simCallsProviders', icon: 'fa-file', access: 'simCallsProviders'}
      ]
    }
  },
  computed: {
    systemSettings: {
      get: function () {
        return this.$store.getters.system_settings
      },
      set: function (newValue) {
        this.$store.commit('setSystemSettings', newValue)
      }
    },
    systemApiHost: {
      get: function () {
        return this.$store.getters.system_settings.api_host
      },
      set: function (newValue) {
        this.$store.commit('setApiHost', newValue)
      }
    },
    websocket_host: {
      get: function () {
        return this.$store.getters.system_settings.websocket_host
      },
      set: function (newValue) {
        this.$store.commit('setWebSocketHost', newValue)
      }
    },
    currentUser: {
      get: function () {
        return this.$store.getters.user
      },
      set: function (newValue) {
        this.$store.commit('setUser', newValue)
      }
    },
    rolesList: {
      get: function () {
        return this.$store.getters.roles
      },
      set: function (newValue) {
        this.$store.commit('setRoles', newValue)
      }
    },
    sipSettings: {
      get: function () {
        return this.$store.getters.sip_settings
      },
      set: function (newValue) {
        this.$store.commit('setSIP', newValue)
      }
    },
    menuState () {
      return this.$store.getters.menuState
    },
    alertState () {
      return this.$store.getters.alertState
    },
    accessDenial () {
      return this.$store.getters.accessDenial
    }
  },
  methods: {
    checkMenuState () {
      if (this.menuState.active === false) {
        this.alertState.active = true
        event.preventDefault()
        return false
      }
      return true
    },
    subQuit () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=subQuit')
        .then(response => (window.location.href = '/'))
    },
    quit () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=quit')
        .then(response => (window.location.href = '/'))
    }
  },
  created () {
    if (window.location.hostname == 'cc.local') {
      // console.log(window.location.hostname)
      this.systemApiHost = 'http://cc.local'
      this.websocket_host = 'ws://cc.local:4444/ws'
    }
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=auth')
      .then(response => {
        if (response.data.user.id < 1) {
          window.location.href = this.systemSettings.api_host + '/login.php'
          // console.log(response.data)
        }
        this.currentUser = response.data.user
        this.rolesList = response.data.roles
        this.sipSettings = response.data.sip_settings
        // console.log(this.currentUser)
        this.dataReady = true
      })
  }
}
</script>

<style lang="less">
  @import "./assets/less/main.less";
</style>



// WEBPACK FOOTER //
// src/App.vue